var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
import { removeAllTagsFromMarkdown } from '../../utils/markdown';
var gtmForGenericBapEvent = function (_a) {
    var eventName = _a.eventName, extraPayload = _a.extraPayload, model = _a.model, trim = _a.trim, gtmBodyStyle = _a.gtmBodyStyle;
    var gtmPayload = __assign(__assign({ event: 'bap_event', bap_event: eventName, body_style: gtmBodyStyle }, extraPayload), { model: model, trim: removeAllTagsFromMarkdown(trim) });
    var filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmForGenericBapEvent;
